import Skeleton from '@mui/material/Skeleton';
import { ImagesLayout } from 'components/library/images/ImagesLayout';

const NUMBER_OF_TILES = 10;

export function ImagesGallerySkeleton() {
  return (
    <ImagesLayout.Gallery>
      {Array.from({ length: NUMBER_OF_TILES }).map(() => (
        <ImagesLayout.GalleryTile key={Math.random()}>
          <ImagesLayout.GalleryTileImage>
            <Skeleton variant="rectangular" width="100%" height="100%" />
          </ImagesLayout.GalleryTileImage>
        </ImagesLayout.GalleryTile>
      ))}
    </ImagesLayout.Gallery>
  );
}
